module.exports = __webpack_public_path__ + "img/plus.b6cc0c15.svg";